import type { SeatView } from '../model/table';
import { seatColorVar } from './seatColors';

export function PlayerArea({ seat, seatIndex, label, children }: { seat: SeatView; seatIndex: Map<string, number>; label: string; children: React.ReactNode }) {
  return (
    <section className={`player-area${seat.isSelf ? ' is-self' : ''}${seat.active ? ' is-active' : ''}`} aria-label={label}
      style={{ '--seat-color': seatColorVar(seatIndex.get(seat.id) ?? 0) } as React.CSSProperties}>
      {children}
    </section>
  );
}
